mutation CreateStreamClip($input: CreateStreamClipInput!) {
  createStreamClip(input: $input) {
    content {
      id
    }
  }
}
